import { RequestService } from '../../../../common/services/RequestService';
import { adjustExecutorsData } from './adjustExecutorsData';
import { GET_ALL_EXECUTORS } from '../constants';

export const getAllExecutorsRequest = async profileId => {
  const response = await RequestService.get(
    GET_ALL_EXECUTORS.replace('{profile_id}', profileId)
  );
  return (
    response.data &&
    Array.isArray(response.data) &&
    response.data.map(executor => adjustExecutorsData(executor))
  );
};
